
import React, { Fragment } from 'react';
import { useIntl } from 'react-intl';

// Components

import SummaryItem from '../SummaryItem';

// Constants

import { OTHER_PROGRAMS_LIST } from '@constants/ssap/hhmTypes/otherProgramsList';


const CurrentCoverageInfo = props => {
    const {
        applyingForCoverageIndicator,
        healthCoverage: {
            currentlyHasHealthInsuranceIndicator,
            currentOtherInsurance: {
                otherStateOrFederalPrograms
            },
            otherInsurance: {
                insuranceName,
                policyNumber,
                limitedBenefit
            }
        },
        idx
    } = props;

    const intlApi = useIntl();

    if(!applyingForCoverageIndicator){
        return null;
    }

    const getPrograms = programs => {
        if(!programs) {
            return 'common.no_text';
        }

        return programs
            .reduce(
                (eligiblePrograms, program) => {
                    const {
                        eligible,
                        type
                    } = program;

                    if(eligible) {
                        return [
                            ...eligiblePrograms,
                            intlApi.formatMessage(
                                {
                                    id: OTHER_PROGRAMS_LIST
                                        .find(p => p.type === type)
                                        .nameId
                                }
                            )
                        ];
                    } else {
                        return eligiblePrograms;
                    }
                },
                [ ]
            )
            .join('; ');
    };
    
    return (
        <Fragment>
            <SummaryItem
                category = 'ssap.additional_info.summary.current_coverage'
                value = { currentlyHasHealthInsuranceIndicator }
                desc = {
                    [
                        [
                            `taxHousehold.householdMember[${ idx }].healthCoverage.currentlyHasHealthInsuranceIndicator`
                        ]
                    ]
                }
            />

            {
                currentlyHasHealthInsuranceIndicator &&

                <Fragment>
                    <SummaryItem
                        textCode = 'common.coverage_type'
                        value = { getPrograms(otherStateOrFederalPrograms) }
                        ignoreIntl
                        desc = {
                            [
                                [
                                    [
                                        `taxHousehold.householdMember[${ idx }].healthCoverage.currentOtherInsurance.otherStateOrFederalPrograms`
                                    ],
                                    getPrograms
                                ]
                            ]
                        }
                    />

                    {
                        (insuranceName || policyNumber || limitedBenefit)  &&

                        <Fragment>
                            <SummaryItem
                                textCode = 'common.insurance_name'
                                value = { insuranceName }
                                ignoreIntl
                                desc = {
                                    [
                                        [
                                            `taxHousehold.householdMember[${ idx }].healthCoverage.otherInsurance.insuranceName`
                                        ]
                                    ]
                                }
                            />
                            <SummaryItem
                                textCode = 'common.policy_number'
                                value = { policyNumber }
                                ignoreIntl
                                desc = {
                                    [
                                        [
                                            `taxHousehold.householdMember[${ idx }].healthCoverage.otherInsurance.policyNumber`
                                        ]
                                    ]
                                }
                            />
                            <SummaryItem
                                textCode = 'common.is_limited_benefit'
                                value = { limitedBenefit }
                                desc = {
                                    [
                                        [
                                            `taxHousehold.householdMember[${ idx }].healthCoverage.otherInsurance.limitedBenefit`
                                        ]
                                    ]
                                }
                            />
                        </Fragment>
                    }
                </Fragment>
            }
        </Fragment>
    );
};

export default CurrentCoverageInfo;